const INITIAL_STATE = {
  data: {},
  errors: {},
}
  
const postPaymentLog = (state = INITIAL_STATE, action) => {
  switch (action.type) {
  case 'CLEAN_PAYMENT_RESPONSE':
    return {...state, ...INITIAL_STATE}
  case 'POST_PAYMENT_HISTORY_SUCCESSFULLY':
	  return { ...state, ...INITIAL_STATE, data: action.data }
  case 'POST_PAYMENT_HISTORY_FAILED':
	  return { ...state, ...INITIAL_STATE, errors: action.data }
  default:
	  return { ...state }
  }
};
  
export default postPaymentLog;
  